module.exports = __webpack_public_path__ + "files/9df1c3c348105cc15cc04950e392b98b.png";